import script from "./meLandDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./meLandDetail.vue?vue&type=script&setup=true&lang=js"

import "./meLandDetail.vue?vue&type=style&index=0&id=685d92e5&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-685d92e5"]])

export default __exports__